import './commitment-count-tooltip.scss';

import { useTranslation } from 'react-i18next';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@sola/ark-core/molecules/tooltip/tooltip.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';

interface CommitmentCountTooltipProps {
  count: number;
}

export const CommitmentCountTooltip = ({
  count,
}: CommitmentCountTooltipProps) => {
  const { t } = useTranslation('my');
  return (
    <Tooltip>
      <TooltipTrigger>
        <button
          type="button"
          className="CommitmentCountTooltip flex items-center justify-center"
          aria-label="Additional information"
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          <ArkIcon iconName="info-circle" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        className="label-md lg:label-lg"
        alignOffset={-12}
        onPointerDownOutside={(e) => {
          e.preventDefault();
        }}
      >
        {t('payments.methodCommitmentsTooltip', {
          count,
        })}
      </TooltipContent>
    </Tooltip>
  );
};
